import { DataValidator, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api from "./api";

export interface TiktokVideoPublishRequest {
  fileUrl: string;
  type: 'video' | 'image';
  thirdAccountIds: string[];
}

export interface TiktokVideoPublishResponse {
  videoId: string;
}

class TiktokVideoPublishData {
  @IsString("Video id must be a string")
  videoId: string;
}

const transformAndValidateData = (
  response: TiktokVideoPublishResponse
): TiktokVideoPublishData => {
  const transformedData = transformKeys(response);

  try {
    return DataValidator.validateOrThrow(transformedData, TiktokVideoPublishData);
  } catch (error) {
    console.error("Tiktok video publish data validation failed:", error.message);
    throw error;
  }
};

// TikTok 发布视频
export const tiktokVideoPublish = async ({
  type,
  fileUrl,
  thirdAccountIds,
}: TiktokVideoPublishRequest) => {
  const res = await api.post<TiktokVideoPublishResponse>("/tiktok/video/upload-file-to-inbox", {
    type,
    fileUrl,
    thirdAccountIds,
  });
  return transformAndValidateData(res.data);
};
